module.exports = __webpack_public_path__ + "static/build-54e252c1ea3e9fe78338c20686ab1fcd.png";